import React from "react";

import { IgButton } from "@intelligems/ig-theme/IgButton";
import { ButtonProps } from "@mui/material";

export const ApplyButton = (props: ButtonProps) => {
  return (
    <IgButton variant="contained" color="primary" sx={{ flex: 1 }} {...props}>
      Apply
    </IgButton>
  );
};
